import React from 'react';
import PropTypes from 'prop-types';
import { gql } from '@apollo/client';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './StaticBlock.css';
import { withQuery } from '../../../hoc/withGraphql';

// Component
import StaticBlockForm from '../../../components/siteadmin/StaticBlockForm/StaticBlockForm';
import Loader from '../../../components/Loader/Loader';

class StaticBlock extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getStaticInfo: PropTypes.object,
    })
  };

  static defaultProps = {
    data: {
      loading: true,
      image: null
    }
  };


  render() {
    const { data: { loading, getStaticInfo } } = this.props;
    let settingsCollection = {};

    if (loading) {
      return <Loader type={"text"} />;
    } else {
      getStaticInfo.map((item, key) => {
        if (item.name == 'header') {
          settingsCollection['headerTitle'] = item.title;
          settingsCollection['headerContent'] = item.content;
          settingsCollection['isEnable'] = item.isEnable;
        } else if (item.name == 'block1') {
          settingsCollection['blockTitle1'] = item.title;
          settingsCollection['blockContent1'] = item.content;
          settingsCollection['blockImage1'] = item.image;
        } else {
          settingsCollection['blockTitle2'] = item.title;
          settingsCollection['blockContent2'] = item.content;
          settingsCollection['blockImage2'] = item.image;
        }
      });
      return <StaticBlockForm initialValues={settingsCollection} />
    }
  }

}

export default compose(
  withStyles(s),
  withQuery(gql`
      {
        getStaticInfo {
            title
            content
            name
            image
            isEnable
          }
      }
      `, {
    options: {
      fetchPolicy: 'network-only',
      ssr: false
    }
  }),
)(StaticBlock);
